module.exports = __webpack_public_path__ + "img/blacklogo.a57dde16.svg";